<mat-expansion-panel class="mt-8 filter-field-container" hideToggle="true" #panel (closed)="closedChange.emit()">
    <mat-expansion-panel-header class="bc-mono-white pt-20 pr-16 pb-20 pl-16">
        <div fxFlex fxLayout="row" fxLayoutAlign="start center" class="no-select">
            <div class="t2-semi-bold">
                {{ label }}
                <ng-content select="[CustomLabel]"/>
            </div>
            <div fxFlex fxLayout="row" fxLayoutAlign="end center" class="w-100">
                @if (isFilterApplied) {
                    <ui-kit-svg class="i-24 c-secondary-red-800" name="ic_close_small" (click)="clear($event)"/>
                }
                @if (panel.expanded) {
                    <ui-kit-svg class="i-24" name="ic_arrow_up"/>
                } @else {
                    <ui-kit-svg class="i-24" name="ic_arrow_down"/>
                }
            </div>
        </div>
    </mat-expansion-panel-header>
    <ng-content/>
</mat-expansion-panel>
